import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "page-top order-from__page-top" }
const _hoisted_2 = { class: "page-top__table-title" }
const _hoisted_3 = {
  key: 0,
  class: "page-top__page-nation"
}
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "page-top__page-nation--arrow-text" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "page-top__page-nation--arrow-text" }
const _hoisted_8 = { class: "page-top__page-nation--current-page" }
const _hoisted_9 = { class: "business-transaction" }
const _hoisted_10 = { class: "business-transaction__table" }
const _hoisted_11 = { class: "order-form-simulation-graph-button-container" }
const _hoisted_12 = { class: "order-form-simulation-graph-button-container__weight-info" }
const _hoisted_13 = { class: "order-form-simulation-graph-button-container__weight-info-row" }
const _hoisted_14 = { class: "order-form-simulation-graph-button-container__weight-info--unit" }
const _hoisted_15 = { class: "order-form-simulation-graph-button-container__weight-info--latest-inventory" }
const _hoisted_16 = { class: "order-form-simulation-graph-button-container__moq-info" }
const _hoisted_17 = { class: "order-form-simulation-graph-button-container__order-package-info" }
const _hoisted_18 = { class: "order-form-simulation-graph-button-container__memo-info" }
const _hoisted_19 = { class: "order-form-simulation-graph-button-container__weight-info-row" }
const _hoisted_20 = { class: "order-form-simulation-graph-button-container__weight-info--responsible-users" }
const _hoisted_21 = { key: 0 }
const _hoisted_22 = { key: 1 }
const _hoisted_23 = { class: "forecast-history__label-container" }
const _hoisted_24 = {
  "data-testid": `forecast_history_label`,
  class: "order-form__table-title"
}
const _hoisted_25 = { class: "forecast-history__label-inner-left" }
const _hoisted_26 = { class: "forecast-history__label-change-month" }
const _hoisted_27 = { class: "forecast-history__label-percentage" }
const _hoisted_28 = { class: "forecast-history__label-percentage--tag" }
const _hoisted_29 = { class: "forecast-history__label-percentage--number" }
const _hoisted_30 = { class: "forecast-history" }
const _hoisted_31 = {
  "data-testid": `forecast_history_frame`,
  class: "table-border__style overflow-scroll"
}
const _hoisted_32 = { class: "forecast-history__table border-collapse bg-white text-sm text-gray-500" }
const _hoisted_33 = { class: "bg-gray-300" }
const _hoisted_34 = { class: "order-form__simulation-graph-header" }
const _hoisted_35 = {
  "data-testid": `forecast_label`,
  class: "order-form__table-title"
}
const _hoisted_36 = { class: "order-form__simulation-graph-header--right" }
const _hoisted_37 = { class: "simulate-graph__container" }
const _hoisted_38 = { class: "slidebar-multithumb" }
const _hoisted_39 = { class: "graph-range-left" }
const _hoisted_40 = { class: "graph-range-right" }
const _hoisted_41 = {
  key: 0,
  class: "simulate-graph__alert-container"
}

import { reactive, computed, onMounted, watch, inject, ref } from 'vue';
import Chart, { IChartdata } from '@/components/atom/Chart.vue';
import { newDefaultData } from '@/appLogic/importData/initialData';
import { calculateDataToDays, dateObjToUnixTime, dateStrToObject } from '@/appLogic/business/businessLogic';
import { simpleCopy } from '@/utils/deepCopy';
import { changeMonthChart, changeDayChart } from '@/appLogic/view/orderChart';
import {
  FORECAST_LENGTH,
  YEAR_TO_MONTH,
  DAY_NUM_OF_BIZDAYS,
  MONTH_NUM_OF_BIZDAYS,
  DAY_STD,
  UNIT_OF_DAY,
  UNIT_OF_WEEK,
  UNIT_OF_MONTH,
} from '@/coreDomainsModule/constants';
import { DateService } from '@/coreDomainsModule/services/dateService';
import calculateRecommendOrderQuantity from '@/appLogic/business/calculateRecommendOrderQuantity';
import {
  stdIndexInfosToStdInventoryIndexObject,
  stdInventoryIndexObjectToStdIndexInfos,
  stdInventoryIndexToDisplayStdIndexInfo,
} from '@/appLogic/business/stdInventoryIndex';
import { i18n } from '@/i18n';
import SelectableSimpleTableContent from './SelectableSimpleTableContent.vue';
import { useRouter } from 'vue-router';
import { objectEquals } from '@/utils/objectEquals';
import TableCell from '@/components/atom/TableCell.vue';
import TableHead from '@/components/atom/TableHead.vue';
import LeadTimePicker from '@/components/modal/LeadTimePicker.vue';
import StdInventoryPicker from '@/components/modal/StdInventoryPicker.vue';
import { FloatPopupState } from '@/appLogic/interfaces/floatPopup';
import WorkDaysCalendarNotYetEnteredAlertModal from '@/components/modal/WorkDaysCalendarNotYetEnteredAlertModal.vue';
import { shouldShowWorkDaysCalendarNotEnteredAlertModal } from '@/appLogic/importData/calendar';
import Modal from '@/components/modal/Modal.vue';
import { IExtraSimulate } from '@/recommendOrderModule/pages/interfaces/extraSimulation';
import { IFutureMonthlyCalculationsRow } from '../pages/interfaces/recommendOrder';
import { loadMyPropertyPreferences, myPropertyPreferences, saveMyPropertyPreferences } from '@/appLogic/view/preferences';
import TextButton from '@/components/input/Btn/TextButton.vue';
import { nullOrUndefinedToMinusOne } from '@/coreDomainsModule/extends/number';
import { IYearMonth } from '@/coreDomainsModule/date';
import { CreateChartDataForCsvUseCase } from '@/exportFileUseCasesModule/createChartDataForCsvUseCase';
import { CreateCsvInfo } from '@/coreDomainsModule/exportFileManage';
import { openFailToSavedModal } from '@/corePagesModule/components/modal/modalActions';
import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { IMvpInventory, StdIndexInfo } from '@/coreDomainsModule/entities/inventory';
import { ISalesResult } from '@/coreDomainsModule/entities/salesResults';
import { FixOrderValue, ISelectFormDataSet, ISelectOption, OrderChartDateUnit, TableType } from '@/coreDomainsModule/table';
import { IDate } from '@/coreDomainsModule/date';
import { IAnnounce } from '@/coreDomainsModule/entities/forecast';
import { IArrival, OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { TableContentViewModel } from '@/viewModels/tableContent';
import { useSelectedBusinessStore } from '../pages/selectedBusinessStore';
import { FORECAST_UPPER_LIMIT, EQUAL_RATE } from '@/recommendOrderModule/constants';
import SvgLoader from '@/utils/SvgLoader.vue';
import { key } from '../pages/useRecommendOrderStore';
import InvalidOrderAlert from './InvalidOrderAlert.vue';
import { AnnounceService } from '../domains/services/announceService';
import MoqInputPopUp from './MoqInputPopUp.vue';
import OrderPackageInputPopUp from './OrderPackageInputPopUp.vue';
import TableMemoButton from '@/corePagesModule/tableMemoButton/TableMemoButton.vue';
import Mdi from '@/corePagesModule/components/Mdi.vue';
import OptimizedTooltipText from '@/corePagesModule/components/OptimizedTooltipText.vue';
import RelatedTransactionsModal from './RelatedTransactionsModal.vue';
import SimpleSelectInput from '@/corePagesModule/components/SimpleSelectInput/SimpleSelectInput.vue';
/**
 *
 */
interface IOrderForm {
  formSet: IBusiness;
  chartData: IChartdata;
  timeUnits: ISelectOption[];
  selectedDateUnit: OrderChartDateUnit;
  calculationUnit: ISelectOption[];
  selectedCalculationUnit: string;
  orderAmount: number;
  deliveryDate: IDate;
  leadTimeSet: ISelectFormDataSet;
  inventoryIndexSet: ISelectFormDataSet;
  moqModelValue: number;
  orderPackageModelValue: number; // 発注単位のモデル値
  stdIndexInfos: StdIndexInfo[];
  displayStdIndexInfo: StdIndexInfo;
  options: ISelectOption[];
  forecastDates: ForecastInfo[]; // 当月入力の内示
  forecastHistory: ForecastInfo[]; // 過去の内示実績
  turnOverHistory: TurnOverInfo[]; // 過去の在庫回転率実績
  inventoryHistory: IMvpInventory[]; // 過去の末在庫履歴
  forecastDatesStack: ForecastInfo[][]; // `forecastDates`の変更履歴スタック(とりあえず計算した場合のみ記録)
  currentForecastIndex: number;
  currentMonthInputSalesResult: ISalesResult[];
  rate: number;
  operator: string;
  isActiveForecastButtons: boolean;
  inputGraphRange: number[];
  differenceFromStartDate: number; // シミュレーション開始日からの差分（開始日を0とする）
  graphRange: number; // グラフの表示範囲(>0)
  isFirstRender: boolean;
  isRenderForecastHistory: boolean;
  quantityRate: number[];
  leadTimePickerState: FloatPopupState; // リードタイムピッカーの表示状態
  stdInventoryPickerState: FloatPopupState; // 標準在庫指数ピッカーの表示状態
  moqInputPopUpState: FloatPopupState; // MOQインプットの表示状態
  orderPackageInputPopUpState: FloatPopupState; // 発注単位インプットの表示状態
  workDaysCalendarNotYetEnteredAlertModalStatus: boolean;
  historyMonthOffset: number;
  formSetCustomerForecastHistory: IAnnounce[]; // DBから受け取った内示情報の履歴情報を入れる用
  isAppearenceUnpaidOrderedOrder: boolean;
  futureForecasts: ForecastInfo[];
  currentMonthData: { salesResult: ISalesResult; quantityRate: number } | undefined;
}

/**
 *  自身の初期数量を持つ内示情報
 */
interface ForecastInfo extends IAnnounce {
  initialAmount: number;
  approvedOrdersAmount: number;
  endOfMonthInventory: number;
  inventoryTurnoverRate: number;
}

/**
 * 在庫回転率情報
 */
interface TurnOverInfo extends IYearMonth {
  turnOver: number; // 在庫回転率
}


export default /*@__PURE__*/_defineComponent({
  __name: 'OrderForm',
  props: {
    item: {},
    formSetCustomerForecastHistory: {},
    tableType: {},
    fixOrderValue: { default: undefined },
    extraSimulateInfos: { default: undefined }
  },
  emits: ["submit", "updateSimulate", "cancel", "updateBusinessId", "pagingUpdate"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "3355942c": (`${state.leadTimePickerState.originCoordinate.y}px`),
  "33477cab": (`${state.leadTimePickerState.originCoordinate.x}px`),
  "80c2cf48": (`${state.stdInventoryPickerState.originCoordinate.y}px`),
  "80defe4a": (`${state.stdInventoryPickerState.originCoordinate.x}px`),
  "5dcdf544": (`${state.moqInputPopUpState.originCoordinate.y}px`),
  "5dea2446": (`${state.moqInputPopUpState.originCoordinate.x}px`),
  "472dedcf": (`${state.orderPackageInputPopUpState.originCoordinate.y}px`),
  "471fd64e": (`${state.orderPackageInputPopUpState.originCoordinate.x}px`)
}))

const props = __props;

const emits = __emit;

/**
 * 取引の発注（recommend）の中から最も遅い入荷予定日(crossDate)をDate型で返す。
 * 分納(partialDeliveries)のcrossDteも対象に含める。
 * 該当する入荷予定日が無い場合はundefinedを返す。
 * @param business - 取引情報
 */
const getLatestArrivalDate = (business: IBusiness): Date | undefined => {
  const recommends = business.recommend ?? [];
  let latest: Date | undefined;
  for (const order of recommends) {
    if (order.crossDate) {
      const d = DateService.convertIDateToDate(order.crossDate);
      if (!latest || d > latest) latest = d;
    }
    if (order.partialDeliveries) {
      for (const pd of order.partialDeliveries) {
        if (pd.crossDate) {
          const d = DateService.convertIDateToDate(pd.crossDate);
          if (!latest || d > latest) latest = d;
        }
      }
    }
  }
  return latest;
};

//変数
const t = i18n.t;
const router = useRouter();
const createChartDataForCsvUseCase = new CreateChartDataForCsvUseCase();
const recommendOrderStore = inject(key);
if (!recommendOrderStore) {
  throw new Error('store is undefined');
}
const { state: useSelectedBusinessState } = useSelectedBusinessStore();

const isExpanded = ref(false);
const state: IOrderForm = reactive<IOrderForm>({
  formSet: newDefaultData,
  selectedDateUnit: 'day',
  timeUnits: [
    { label: '稼働日ごとの在庫予想', value: 'day' },
    { label: '月ごとの在庫予想', value: 'month' },
  ],
  selectedCalculationUnit: 'multiplication',
  calculationUnit: [
    { label: '×', value: 'multiplication' },
    { label: '÷', value: 'division' },
  ],
  chartData: {
    labels: [],
    datasets: [],
  },
  orderAmount: 0,
  deliveryDate: dateStrToObject(
    new Date().getTime() + (props.item.leadTime && props.item.leadTime >= 0 ? props.item.leadTime * DAY_STD : 0)
  ),
  stdIndexInfos: [{ min: -1, max: 0, name: t('標準在庫指数(下限)(詳細ページ)'), unit: 'day' }],
  displayStdIndexInfo: { min: -1, max: 0, name: t('標準在庫指数(上限)(詳細ページ)'), unit: 'day' },
  leadTimeSet: {
    displayData: -1,
    selectedUnit: 'day',
  },
  inventoryIndexSet: {
    displayData: -1,
    selectedUnit: 'day',
  },
  moqModelValue: 0,
  orderPackageModelValue: 0,
  options: [
    { label: UNIT_OF_DAY, value: 'day' },
    { label: UNIT_OF_WEEK, value: 'week' },
    { label: UNIT_OF_MONTH, value: 'month' },
  ],
  rate: 0,
  operator: 'multiplication',
  isActiveForecastButtons: false,
  forecastDates: [],
  forecastHistory: [],
  turnOverHistory: [],
  inventoryHistory: [],
  forecastDatesStack: [],
  currentForecastIndex: 0,
  currentMonthInputSalesResult: [],
  inputGraphRange: [0, 180],
  differenceFromStartDate: 0,
  graphRange: 180,
  isFirstRender: true,
  isRenderForecastHistory: true,
  quantityRate: [],
  leadTimePickerState: { shouldShow: false, originCoordinate: { x: 0, y: 0 } },
  stdInventoryPickerState: { shouldShow: false, originCoordinate: { x: 0, y: 0 } },
  moqInputPopUpState: { shouldShow: false, originCoordinate: { x: 0, y: 0 } },
  orderPackageInputPopUpState: { shouldShow: false, originCoordinate: { x: 0, y: 0 } },
  workDaysCalendarNotYetEnteredAlertModalStatus: false,
  historyMonthOffset: 1,
  formSetCustomerForecastHistory: [],
  isAppearenceUnpaidOrderedOrder: false,
  futureForecasts: [],
  currentMonthData: undefined,
}) as IOrderForm;

/**
 * forecastDateの関数
 * @param announces - 内示情報
 * @param date - component表示時の日時情報
 */
const forecastDateFunction = (
  announces: IAnnounce[],
  date: IDate = dateStrToObject(new Date().getTime())
): { [key: string]: ForecastInfo } => {
  const map: { [key: string]: ForecastInfo } = {};
  let target = new Date(dateObjToUnixTime(date));
  let year = date.year;
  let month = date.month;
  for (let i = 0; i < FORECAST_LENGTH; i++) {
    map[`${year}-${month}`] = {
      year: year,
      month: month,
      amount: 0,
      initialAmount: 0,
      manageInitiatedYearMonth: undefined,
      createAt: undefined,
      updateAt: undefined,
    };
    target = new Date(year, month - 1, 3);
    year = target.getFullYear();
    month = target.getMonth() + 1;
  }
  for (const announce of announces || []) {
    const year = announce.year;
    const month = announce.month;
    if (map[`${year}-${month}`] !== undefined) {
      map[`${year}-${month}`].amount = announce.amount;
    }
  }
  return map;
};
/**
 * 販売実績の過去実績を作成する
 * @param salesResults - 実績情報
 * @param date - component表示時の日時情報
 */
const salesResultDateHistoryFunction = (
  salesResults: ISalesResult[],
  date: IDate = dateStrToObject(new Date().getTime())
): { [key: string]: ISalesResult } => {
  const map: { [key: string]: ISalesResult } = {};
  let target = new Date(dateObjToUnixTime(date));
  let year = date.year;
  let month = date.month;
  // 現在の月から過去12ヶ月分の年月情報を作成する
  for (let i = 0; i < YEAR_TO_MONTH; i++) {
    const oldYear = year - 1;
    map[`${oldYear}-${month}`] = { year: oldYear, month: month, amount: 0 };
    target = new Date(year, month - 1, 3);
    month++;
    if (month > 12) {
      year++;
      month = 1;
    }
  }
  for (const salesResult of salesResults || []) {
    const year = salesResult.year;
    const month = salesResult.month;
    if (map[`${year}-${month}`] !== undefined) {
      map[`${year}-${month}`].amount = salesResult.amount;
    }
  }
  return map;
};

/**
 * 在庫の過去実績を作成する
 * @param inventories - 実績情報
 * @param date - component表示時の日時情報
 */
const inventoryDateHistoryFunction = (
  inventories: IMvpInventory[],
  date: IDate = dateStrToObject(new Date().getTime())
): { [key: string]: IMvpInventory } => {
  const map: { [key: string]: IMvpInventory } = {};
  let target = new Date(dateObjToUnixTime(date));
  let year = date.year;
  let month = date.month;
  // 現在の月から過去12ヶ月分の年月情報を作成する
  for (let i = 0; i < YEAR_TO_MONTH; i++) {
    const oldYear = year - 1;
    map[`${oldYear}-${month}`] = { year: oldYear, month: month, amount: 0 };
    target = new Date(year, month - 1, 3);
    month++;
    if (month > 12) {
      year++;
      month = 1;
    }
  }
  for (const inventory of inventories || []) {
    const year = inventory.year;
    const month = inventory.month;
    if (map[`${year}-${month}`] !== undefined) {
      map[`${year}-${month}`].amount = inventory.amount;
    }
  }
  return map;
};

/**
 * 過去の内示実績12ヶ月分の情報をmapとして生成する
 * @param announces - 内示情報
 * @param date - component表示時の日時情報
 */
const forecastDateHistoryFunction = (
  announces: IAnnounce[],
  date: IDate = dateStrToObject(new Date().getTime())
): { [key: string]: ForecastInfo } => {
  const map: { [key: string]: ForecastInfo } = {};
  let target = new Date(dateObjToUnixTime(date));
  let year = date.year;
  let month = date.month;

  // 現在の月から過去12ヶ月分の年月情報を作成する
  for (let i = 0; i < YEAR_TO_MONTH; i++) {
    const oldYear = year - 1;
    map[`${oldYear}-${month}`] = {
      year: oldYear,
      month: month,
      amount: 0,
      initialAmount: 0,
      manageInitiatedYearMonth: undefined,
      createAt: undefined,
      updateAt: undefined,
    };
    target = new Date(year, month - 1, 3);
    month++;
    if (month > 12) {
      year++;
      month = 1;
    }
  }

  // 内示情報を年月で昇順、受領年月で降順にソートする
  const announceHistories: IAnnounce[] = AnnounceService.sortAnnounceHistories(simpleCopy(announces));

  const filteredAnnounceHistories: IAnnounce[] = announceHistories.filter((ent) => {
    const thresholdInitiatedDate = DateService.updateYearMonth(ent.year, ent.month, -state.historyMonthOffset);
    return (
      ent.manageInitiatedYearMonth &&
      ent.manageInitiatedYearMonth.month <= thresholdInitiatedDate.updateMonth &&
      ent.manageInitiatedYearMonth.year <= thresholdInitiatedDate.updateYear
    );
  });

  // 欲しい情報をフィルター済みの内示情報から取得する
  // NOTE: ソート&フィルター済みの内示情報配列から、指定した対象年月の内示情報が1個欲しいのでfindを使っている (見つけた先頭の情報が欲しい)
  for (const mapKey of Object.keys(map)) {
    const year = map[mapKey].year;
    const month = map[mapKey].month;
    // ソート&フィルター済みの内示情報配列から、指定した対象年月の先頭データを取得する
    map[mapKey].amount = filteredAnnounceHistories.find((ent) => ent.year === year && ent.month === month)?.amount ?? 0;
  }
  return map;
};

/**
 * 未来の内示24ヶ月分の情報をmapとして生成する
 * @param announces - 内示情報
 */
const calculateFutureForecasts = (announces: IAnnounce[]): ForecastInfo[] => {
  // ステップ1: 未来24ヶ月分の列を用意する
  const futureMonthsScaffold: ForecastInfo[] = [];
  const today = new Date();
  for (let i = 0; i < 24; i++) {
    const targetDate = new Date(today.getFullYear(), today.getMonth() + i, 1);
    futureMonthsScaffold.push({
      year: targetDate.getFullYear(),
      month: targetDate.getMonth() + 1,
      amount: 0,
      approvedOrdersAmount: 0,
      endOfMonthInventory: 0,
      inventoryTurnoverRate: 0,
      initialAmount: 0,
      manageInitiatedYearMonth: undefined,
      createAt: undefined,
      updateAt: undefined,
    });
  }

  // ステップ2: 「中身」となる内示データを計算する
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth() + 1;

  // 2-a. 未来の内示レコードだけを抽出
  const futureAnnounces = (announces || []).filter((announce) => {
    return announce.year > currentYear || (announce.year === currentYear && announce.month >= currentMonth);
  });

  // 2-b. 「nヶ月前」の閾値で絞り込み
  const thresholdDate = new Date();
  thresholdDate.setMonth(thresholdDate.getMonth() - state.historyMonthOffset);
  const thresholdYear = thresholdDate.getFullYear();
  const thresholdMonth = thresholdDate.getMonth() + 1;

  const filteredAnnounces = futureAnnounces.filter((announce) => {
    if (!announce.manageInitiatedYearMonth) return false;
    const receivedYear = announce.manageInitiatedYearMonth.year;
    const receivedMonth = announce.manageInitiatedYearMonth.month;
    return receivedYear < thresholdYear || (receivedYear === thresholdYear && receivedMonth <= thresholdMonth);
  });

  // 2-c. 各未来月ごとにnヶ月以上前で最新の内示を選択
  const latestForecastsMap = new Map<string, IAnnounce>();
  filteredAnnounces.forEach((announce) => {
    const key = `${announce.year}-${announce.month}`;
    const existing = latestForecastsMap.get(key);
    if (
      !existing ||
      (existing.manageInitiatedYearMonth &&
        announce.manageInitiatedYearMonth &&
        (existing.manageInitiatedYearMonth.year < announce.manageInitiatedYearMonth.year ||
          (existing.manageInitiatedYearMonth.year === announce.manageInitiatedYearMonth.year &&
            existing.manageInitiatedYearMonth.month < announce.manageInitiatedYearMonth.month)))
    ) {
      latestForecastsMap.set(key, announce);
    }
  });

  // ステップ3: 未来内示数を入れる
  futureMonthsScaffold.forEach((monthData) => {
    const key = `${monthData.year}-${monthData.month}`;
    const forecastData = latestForecastsMap.get(key);
    if (forecastData) {
      monthData.amount = forecastData.amount;
      monthData.manageInitiatedYearMonth = forecastData.manageInitiatedYearMonth;
      monthData.createAt = forecastData.createAt;
      monthData.updateAt = forecastData.updateAt;
    }
  });

  // ===== Step3: 在庫計算 =====

  const sortedInventory = [...(state.formSet.mvpInventory || [])]
    // 当月以降の在庫がもし入っていても無視する
    .filter((i) => DateService.compareYearMonths(i, DateService.getShiftedIYearMonthFromNowDateByMonths(0)) === -1)
    .sort((a, b) => {
      if (a.year !== b.year) return b.year - a.year;
      return b.month - a.month;
    });

  let previousMonthEndInventory = sortedInventory.length > 0 ? sortedInventory[0].amount : state.formSet.inventory ?? 0;

  futureMonthsScaffold.forEach((m) => {
    const approvedOrdersAmount =
      state.formSet.recommend
        ?.filter(
          (item) =>
            item.status !== undefined &&
            item.status !== OrderStatus.Recommended &&
            item.status !== OrderStatus.ApprovalRequested &&
            item.status !== OrderStatus.Delivered &&
            item.status !== OrderStatus.DisplayEnded &&
            item.status !== OrderStatus.Unknown
        )
        .filter((item) => {
          if (!item.crossDate) return false;
          const d = DateService.convertIDateToDate(item.crossDate);
          return d.getFullYear() === m.year && d.getMonth() + 1 === m.month;
        })
        .reduce((sum, item) => sum + item.amount, 0) ?? 0;

    m.approvedOrdersAmount = approvedOrdersAmount;

    const endOfMonthInventory = previousMonthEndInventory + approvedOrdersAmount - m.amount;

    m.endOfMonthInventory = Math.round(endOfMonthInventory);

    m.inventoryTurnoverRate = m.amount > 0 ? Math.round((endOfMonthInventory / m.amount) * 100) / 100 : 0;

    previousMonthEndInventory = endOfMonthInventory;
  });

  return futureMonthsScaffold;
};

/**
 * 内示履歴と販売実績履歴をセットする
 */
const setHistoryValue = () => {
  const forecastDatesMap: { [key: string]: ForecastInfo } = forecastDateFunction(state.formSet.customerAnnounce || []);
  const salesResultHistoryMap: {
    [key: string]: ISalesResult;
  } = salesResultDateHistoryFunction(state.formSet?.salesResults || []);
  const inventoryHistoryMap: { [key: string]: IMvpInventory } = inventoryDateHistoryFunction(state.formSet?.mvpInventory || []);
  state.forecastDates = Object.values(forecastDatesMap)
    .sort(function (a, b) {
      const aValue = a.year * 100 + a.month;
      const bValue = b.year * 100 + b.month;
      return aValue - bValue;
    })
    .map((forecastDate) => {
      forecastDate.initialAmount = forecastDate.amount;
      return forecastDate;
    });
  pushForecastSnapshot(state.forecastDates);

  const forecastResultHistoryMap: {
    [key: string]: ForecastInfo;
  } = forecastDateHistoryFunction(state.formSetCustomerForecastHistory || []);

  state.forecastHistory = Object.values(forecastResultHistoryMap).sort(function (a, b) {
    const aValue = a.year * 100 + a.month;
    const bValue = b.year * 100 + b.month;
    return aValue - bValue;
  });
  // 日付の昇順に、とりあえず最新４月分の履歴を扱う
  state.currentMonthInputSalesResult = Object.values(salesResultHistoryMap).sort(function (a, b) {
    const aValue = a.year * 100 + a.month;
    const bValue = b.year * 100 + b.month;
    return aValue - bValue;
  });
  state.inventoryHistory = Object.values(inventoryHistoryMap).sort(function (a, b) {
    const aValue = a.year * 100 + a.month;
    const bValue = b.year * 100 + b.month;
    return aValue - bValue;
  });
};

/**
 * 当月の販売実績を計算する
 * @param salesResults - 全ての販売実績データ
 */
const calculateCurrentMonthSalesResult = (salesResults: ISalesResult[]): ISalesResult | undefined => {
  const now = dateStrToObject(new Date().getTime());
  return salesResults.find((v) => v.year == now.year && v.month == now.month);
};

// イベントフック
onMounted(async () => {
  await loadMyPropertyPreferences();
  state.isAppearenceUnpaidOrderedOrder =
    myPropertyPreferences.order.unpaidOrderedOrderAppearance && recommendOrderStore.state.unpaidOrderedOrder.length > 0;
  let prefRange = myPropertyPreferences['simulation']?.graphRange;
  if (prefRange !== undefined && prefRange > 180) prefRange = 180; // NOTE: 180日以上に万が一設定されていた場合は180日に設定する

  state.graphRange = prefRange ?? state.graphRange;
  state.inputGraphRange = [0, state.graphRange];

  const copyItem = Object.assign({}, props.item ?? {});
  if (props.item?.leadTime) {
    state.leadTimeSet = vm.getLeadTimeFormDataSet(props.item.leadTime);
  }
  if (props.item?.MOQ) {
    state.moqModelValue = props.item.MOQ;
  }

  // 客先内示情報の履歴情報を入れる
  const copyCustomerForecast = simpleCopy(props.formSetCustomerForecastHistory);
  state.formSetCustomerForecastHistory = copyCustomerForecast;

  // state.inventoryIndexSet.displayData = props.item ? props.item.stdInventoryIndices : undefined;
  state.inventoryIndexSet.displayData = undefined;
  const expectedQuantity = calculateRecommendOrderQuantity(copyItem);
  state.formSet = copyItem;
  state.stdIndexInfos = [];
  state.stdIndexInfos = stdInventoryIndexObjectToStdIndexInfos(copyItem.stdInventoryIndices || {});
  state.displayStdIndexInfo = stdInventoryIndexToDisplayStdIndexInfo(copyItem.stdInventoryIndices || {})[0];
  state.orderAmount = expectedQuantity as number;
  if (props.fixOrderValue) {
    state.orderAmount = props.fixOrderValue.orderAmount;
    state.deliveryDate = props.fixOrderValue.deliveryDate;
  }

  setHistoryValue();
  state.futureForecasts = calculateFutureForecasts(state.formSetCustomerForecastHistory);
  const currentMonthSalesResult = calculateCurrentMonthSalesResult(state.formSet?.salesResults || []);
  state.currentMonthData = currentMonthSalesResult
    ? {
        salesResult: currentMonthSalesResult,
        quantityRate: getQuantityRate(
          state.futureForecasts.find((v) => v.year == currentMonthSalesResult.year && v.month == currentMonthSalesResult.month)?.amount ??
            0,
          currentMonthSalesResult.amount
        ),
      }
    : undefined;
  renderChart();
  initQuantityRate();
  initTurnOver();
  // 内示計算用の割合の初期値 過去実績の平均正答率を入力する
  state.rate = isNaN(calcAverageQuantityRate()) ? 0 : Math.floor(calcAverageQuantityRate() * 10) / 1000;
  state.historyMonthOffset = 1;
});

watch(
  () => props.item,
  () => {
    renderChart();
  }
);
watch(
  () => state.selectedDateUnit,
  () => {
    state.graphRange = state.selectedDateUnit === 'month' ? MONTH_NUM_OF_BIZDAYS : DAY_NUM_OF_BIZDAYS;
    renderChart().then(() => (state.formSet = Object.assign({}, props.item ?? {})));
  }
);
watch(
  () => state.inputGraphRange,
  async () => {
    const rangeValue0 = state.inputGraphRange[0];
    const rangeValue1 = state.inputGraphRange[1];

    state.differenceFromStartDate = Math.min(rangeValue0, rangeValue1);
    const scale = Math.abs(rangeValue0 - rangeValue1);
    if (scale > 0) {
      state.graphRange = scale;
      // myPropertyPreferencesに保存
      myPropertyPreferences['simulation'] = {
        graphRange: scale,
      };
      await saveMyPropertyPreferences();
    } else {
      state.graphRange = 1; // 最低1日は表示する
    }
    renderChart();
  },
  { deep: true }
);
watch(
  () => props.extraSimulateInfos,
  () => {
    renderChart();
  }
);
watch(
  () => i18n.locale,
  () => {
    renderChart();
  }
);

/**
 * 表示情報を更新ボタンの活性化判定
 * NOTE: selectedInfoに差分がある場合＆selectedInfoが全て埋まっている状態（未選択は許容しない）
 */
const disableUpdateBusinessBtn = computed(() => {
  return (
    objectEquals(recommendOrderStore.state.selectedInitialInfo, recommendOrderStore.state.selectedInfo) ||
    recommendOrderStore.state.selectedInfo.supplierName === '' ||
    recommendOrderStore.state.selectedInfo.warehouse === '' ||
    recommendOrderStore.state.selectedInfo.businessCode === '' ||
    recommendOrderStore.state.selectedInfo.businessName === '' ||
    recommendOrderStore.state.selectedInfo.packageAmount === ''
  );
});
//関数
/**
 * チャートの再描画
 */
const renderChart = async () => {
  let business = simpleCopy(props.item ?? {});
  business.leadTime = state.formSet.leadTime;
  business.stdInventoryIndices = stdIndexInfosToStdInventoryIndexObject(state.stdIndexInfos);

  const orderAmount = state.orderAmount;
  state.workDaysCalendarNotYetEnteredAlertModalStatus = await shouldShowWorkDaysCalendarNotEnteredAlertModal();
  if (!state.isFirstRender) business = reflectForecastSimulation(business);
  state.isFirstRender = false;
  const simple =
    state.selectedDateUnit === 'month'
      ? await changeMonthChart(business, orderAmount, state.deliveryDate, props.extraSimulateInfos)
      : await changeDayChart(
          business,
          orderAmount,
          state.graphRange,
          state.differenceFromStartDate,
          dateStrToObject(props.item.executionDate ?? new Date()),
          props.extraSimulateInfos,
          getLatestArrivalDate(props.item)
        );
  // context.root.$set(state, 'chartData', simple);
  state.chartData = Object.assign({}, simple ?? { labels: [], datasets: [] });
  // 発注済み未納を追加する
  if (state.isAppearenceUnpaidOrderedOrder) {
    const unpaidOrderedOrderAmount = recommendOrderStore.state.unpaidOrderedOrder.reduce((acc, order) => {
      acc += order.amount;
      return acc;
    }, 0);
    state.chartData.datasets.push({
      label: t('未入荷在庫'),
      data: [unpaidOrderedOrderAmount, ...Array(179)],
      borderRadius: 5,
      backgroundColor: '#d50000',
      order: 999,
    });
  }
  reFleshRecommend(business);
  emits('updateSimulate', business.recommend);
};

/**
 * オーダーを変更する
 * @param orderAmount - オーダー数量
 */
const changeOrder = (orderAmount: number) => {
  state.orderAmount = orderAmount;
  renderChart();
};
/**
 * @param value - 数量
 * @param index - インデックス
 */
const forecastChange = (value, index) => {
  state.forecastDates[index].amount = value;
  renderChart();
};
/**
 * @param value - 数量
 */
const stdIndexChange = (value: StdIndexInfo) => {
  state.displayStdIndexInfo = value;
  state.stdIndexInfos[0] = simpleCopy(value);
  state.formSet = {
    ...state.formSet,
    stdInventoryIndices: { [value.name]: { min: value.min, max: value.max, option: { unit: value.unit } } },
  };
  renderChart();
};
const vm = new TableContentViewModel();
// リードタイムの変更を検知して、希望納期に反映させる
/**
 * @param value - リードタイム
 */
const leadTimeChange = (value: ISelectFormDataSet) => {
  state.leadTimeSet = value;
  const leadTime = simpleCopy(state.leadTimeSet);
  state.formSet = {
    ...state.formSet,
    leadTime: calculateDataToDays(leadTime),
  };

  state.deliveryDate = dateStrToObject(
    new Date().getTime() + (calculateDataToDays(leadTime) >= 0 ? calculateDataToDays(leadTime) * DAY_STD : 0)
  );
  renderChart();
};
/**
 */
const orderFormEl = () => {
  const dialog = document.getElementsByClassName('md-datepicker-dialog');
  if (dialog.length > 0) {
    (dialog[0] as any).style.opacity = '0.5';
    /**
     */
    (dialog[0] as any).onclick = function () {
      (dialog[0] as any).style.opacity = '1';
    };
  }
  state.isActiveForecastButtons = false;
};
/**
 */
const onClickDatePicker = () => {
  const dialog = document.getElementsByClassName('md-datepicker-dialog');
  if (dialog.length > 0) {
    (dialog[0] as any).style.opacity = '1';
  }
};
/**
 * @param business - 取引
 */
const reflectForecastSimulation = (business: IBusiness) => {
  let realAnnounce: IAnnounce[] = [];
  const realAnnounceMap: { [key: string]: IAnnounce } = {};
  business.customerAnnounce &&
    business.customerAnnounce.forEach((a) => {
      // サンプルデータにバグがあったのでわざわざこんなことを行っているが本当は自明なので行わなくてよい。
      // 重複排除
      const key = a.year * YEAR_TO_MONTH + a.month;
      if (realAnnounceMap[key] === undefined) {
        realAnnounceMap[key] = a;
      } else {
        realAnnounceMap[key].amount = a.amount;
      }
    });
  realAnnounce = Object.values(realAnnounceMap).sort(function (a, b) {
    // サンプルデータにバグがあったのでわざわざこんなことを行っているが本当は自明なので行わなくてよい。
    // 順序
    const aValue = a.year * 100 + a.month;
    const bValue = b.year * 100 + b.month;
    return aValue - bValue;
  });
  let simulationForecastIndex = 0;
  let realBusinessIndex = 0;
  const adaptAnnounce: IAnnounce[] = [];
  while (true) {
    // 尺取法
    const realValue = realAnnounce[realBusinessIndex];
    const simulationValue = state.forecastDates[simulationForecastIndex];
    if (realValue !== undefined && simulationValue !== undefined) {
      // 両方とも存在する時
      const realTime = realValue.year * YEAR_TO_MONTH + realValue.month;
      const simulationTime = simulationValue.year * YEAR_TO_MONTH + simulationValue.month;
      if (realTime == simulationTime) {
        adaptAnnounce.push(simulationValue); //　被った場合はsimulationを適応
        simulationForecastIndex++;
        realBusinessIndex++;
      } else if (simulationTime < realTime) {
        //　それ以外では比較して、過去になるものを採用
        adaptAnnounce.push(simulationValue);
        simulationForecastIndex++;
      } else {
        adaptAnnounce.push(realValue);
        realBusinessIndex++;
      }
    } else {
      if (realValue === undefined && simulationValue === undefined) {
        break;
      } else if (simulationValue === undefined) {
        adaptAnnounce.push(realValue);
        realBusinessIndex++;
      } else if (realValue === undefined) {
        adaptAnnounce.push(simulationValue);
        simulationForecastIndex++;
      }
    }
  }
  business.customerAnnounce = adaptAnnounce;
  return business;
};
/**
 *　　モーダルを閉じる
 */
const closeModal = () => {
  closeWorkDaysCalendarNotYetEnteredAlertModal();
  emits('cancel', false);
};

/**
 *  モーダルを閉じる
 */
const closeWorkDaysCalendarNotYetEnteredAlertModal = () => {
  state.workDaysCalendarNotYetEnteredAlertModalStatus = false;
};

/**
 * 実働勘案内示数量の計算を行う
 * 計算後は計算結果をチャートに反映させる
 */
const adaptRate = () => {
  state.isActiveForecastButtons = false;
  const forecastDates = simpleCopy(state.forecastDates);
  let canAdaptRate = true;
  switch (state.operator) {
    case 'multiplication':
      for (let i = 0; i < forecastDates.length; i++) {
        forecastDates[i].amount *= Number(state.rate);
        forecastDates[i].amount = Math.floor(forecastDates[i].amount + 0.5);
        if (canAdaptRate) {
          canAdaptRate = forecastDates[i].amount.isValidNumber({ upper: FORECAST_UPPER_LIMIT });
        }
      }
      break;
    case 'division':
      for (let i = 0; i < forecastDates.length; i++) {
        forecastDates[i].amount /= Number(state.rate);
        forecastDates[i].amount = Math.floor(forecastDates[i].amount + 0.5);
        if (canAdaptRate) {
          canAdaptRate = forecastDates[i].amount.isValidNumber({ upper: FORECAST_UPPER_LIMIT });
        }
      }
      break;
  }
  if (!canAdaptRate) {
    // TODO: 上限を超えるため更新できない旨をアラートで知らせる
    return;
  }
  if (!objectEquals(state.forecastDates, forecastDates)) {
    state.forecastDates = forecastDates;
    pushForecastSnapshot(state.forecastDates);
    renderChart();
    resetForecastRate();
  }
};

/**
 * 内示数量の更新履歴をスタックに追加
 * @param snapshot - 新規更新履歴
 */
const pushForecastSnapshot = (snapshot: ForecastInfo[]) => {
  // 新しい情報を追加する際、現在より先の情報は破棄する
  if (state.currentForecastIndex !== state.forecastDatesStack.length - 1) {
    state.forecastDatesStack = state.forecastDatesStack.slice(0, state.currentForecastIndex + 1);
  }
  // 変更履歴は最大10件まで記録しておく
  if (state.forecastDatesStack.length === 10) {
    // 10件溜まっていたら一番古いものから削除
    state.forecastDatesStack.shift();
  }
  state.forecastDatesStack.push(snapshot);
  // 表示する最新の情報が入っているindexを更新する
  state.currentForecastIndex = state.forecastDatesStack.length - 1;
};

/**
 * 現在、戻るボタンが有効かどうかを確認する関数
 * @returns 戻るボタンが有効かどうか
 */
const canUndoForecastStack = (): boolean => {
  return state.currentForecastIndex !== 0;
};

/**
 * 現在、進むボタンが有効かどうかを確認する関数
 * @returns 進むボタンが有効かどうか
 */
const canRedoForecastStack = (): boolean => {
  return state.currentForecastIndex !== state.forecastDatesStack.length - 1;
};

/**
 * Undo(戻る)機能。内示数量を一つ前の更新履歴で上書きする関数
 */
const undoForecastStack = () => {
  if (!canUndoForecastStack()) {
    return;
  }
  state.currentForecastIndex--;
  state.forecastDates = simpleCopy(state.forecastDatesStack[state.currentForecastIndex]);
  renderChart();
};

/**
 * Redo(進む)機能。内示数量を一つ後の更新履歴で上書きする関数
 */
const redoForecastStack = () => {
  if (!canRedoForecastStack()) {
    return;
  }
  state.currentForecastIndex++;
  state.forecastDates = simpleCopy(state.forecastDatesStack[state.currentForecastIndex]);
  renderChart();
};

/**
 * 内示数量を初期値に戻す
 */
const resetForecastCalculationResults = () => {
  if (state.forecastDates.every((forecast) => forecast.amount === forecast.initialAmount)) {
    return;
  }
  state.forecastDates = state.forecastDates.map((forecast) => {
    forecast.amount = forecast.initialAmount;
    return forecast;
  });
  pushForecastSnapshot(state.forecastDates);
  renderChart();
};

/**
 * 乗算/除算切り替え時にstate.operatorを切り替える
 * @param operator - 乗算/除算の処理分岐に使う値
 */
const updateOperator = (operator: string) => {
  state.isActiveForecastButtons = false;
  state.operator = operator;
};
/**
 * @param value - 数量
 */
const setDetliveryDate = (value: number) => {
  state.deliveryDate = dateStrToObject(value);
  renderChart();
};
/**
 * @param input - 取引
 */
const reFleshRecommend = (input: IBusiness) => {
  state.formSet.recommend = input.recommend ?? [];
};
const displayDeliveryDate = computed({
  /**
   * @returns - 表示用の納期
   */
  get: () => dateObjToUnixTime(state.deliveryDate) || new Date().getTime(),
  /**
   * @param value - 納期
   */
  set: (value: number) => setDetliveryDate(value),
});

/**
 * 内示/販売実績の正答率計算を行う
 * 計算で、分母に0などを行い値がNaNになった場合は、'-'を返すようにする
 * @param forevastValue - 内示の値
 * @param salesResultValue - 販売実績の値
 */
const getQuantityRate = (forevastValue: number, salesResultValue: number) => {
  // 0除算の回避 分母に0が入る場合infinityになるため、そのような場合は0を返す
  const quantityRate: number = forevastValue !== 0 ? (salesResultValue / forevastValue) * 100 : 0;
  if (!Number.isNaN(quantityRate) && quantityRate !== 0) {
    return Math.floor(quantityRate * 10) / 10;
  } else {
    return 0;
  }
};

/**
 * 内示/販売実績の正答率計算を行う
 * 計算で、分母に0などを行い値がNaNになった場合は、'-'を返すようにする
 */
const initQuantityRate = (): void => {
  state.forecastHistory.forEach((value, index) => {
    const forecastValue = value.amount ?? 0;
    const salesResultValue = state.currentMonthInputSalesResult[index].amount ?? 0;
    state.quantityRate.push(getQuantityRate(forecastValue, salesResultValue));
  });
};

/**
 * 過去の在庫回転率情報の初期化
 * 在庫回転率は、在庫量 / 内示量で計算される
 * 在庫量が0または内示量が0の場合は、0を入れる
 * 在庫回転率の計算結果は小数点以下2桁まで表示する
 */
const initTurnOver = (): void => {
  state.forecastHistory.forEach((value, index) => {
    const forecastValue = value.amount ?? 0;
    const inventoryValue = state.inventoryHistory[index].amount ?? 0;
    // 0除算の回避 分母に0が入る場合infinityになるため、そのような場合は0を入れる
    if (forecastValue === 0 || inventoryValue === 0) {
      state.turnOverHistory.push({
        year: value.year,
        month: value.month,
        turnOver: 0,
      });
      return;
    }
    // 在庫回転率の計算
    const turnOver: number = inventoryValue / forecastValue;
    if (!Number.isNaN(turnOver) && turnOver !== 0) {
      state.turnOverHistory.push({
        year: value.year,
        month: value.month,
        turnOver: Math.floor(turnOver * 100) / 100, // 小数点以下2桁まで表示
      });
    } else {
      state.turnOverHistory.push({
        year: value.year,
        month: value.month,
        turnOver: 0,
      });
    }
  });
};

/**
 * 内示/販売実績の正答率の平均値を計算して出力する
 * 出力する際は、%表示するために割合*100して、文字列にして返す
 */
const calcAverageQuantityRate = (): number => {
  // 過去12ヶ月分の内示合計
  const forecastTotal = state.forecastHistory.reduce((sum, ele) => {
    return sum + ele.amount;
  }, 0);
  // 過去12ヶ月分の販売実績合計
  const salesResultTotal = state.currentMonthInputSalesResult.reduce((sum, ele) => {
    return sum + ele.amount;
  }, 0);

  return forecastTotal !== 0 ? Math.floor((salesResultTotal / forecastTotal) * 1000) / 10 : 0;
};
/**
 *　内示/販売実績の正答率の平均値を計算して出力する
 */
const switchAnnounceMode = () => {
  state.isRenderForecastHistory = !state.isRenderForecastHistory;
};
const showAnnounceHistory = computed(() => {
  if (state.isRenderForecastHistory) {
    return state.forecastHistory;
  } else {
    return [];
  }
});
const showSalesResultHistory = computed(() => {
  if (state.isRenderForecastHistory) {
    return state.currentMonthInputSalesResult;
  } else {
    return [];
  }
});
const showInventoryHistory = computed(() => {
  if (state.isRenderForecastHistory) {
    return state.inventoryHistory;
  } else {
    return [];
  }
});
const showRecommendDate = computed(() => {
  if (state.formSet.recommend) {
    return state.formSet.recommend;
  } else {
    return state.formSet.recommend;
  }
});
const showRecommendAmount = computed(() => {
  if (state.isRenderForecastHistory) {
    return state.currentMonthInputSalesResult;
  } else {
    return [];
  }
});
const showQuantityRate = computed(() => {
  if (state.isRenderForecastHistory) {
    return state.quantityRate;
  } else {
    return [];
  }
});
const showTurnOverHistory = computed(() => {
  if (state.isRenderForecastHistory) {
    return state.turnOverHistory;
  } else {
    return [];
  }
});
/**
 *　 @param operater - オペレータ
 */
const showGraphRange = (operater: string): string => {
  const baseDate = new Date(props.item.executionDate ?? new Date().getTime());

  if (operater === 'right') {
    // 現在より180日分表示するようにする
    baseDate.setDate(baseDate.getDate() + 180);
  }
  const yearStr = baseDate.getFullYear();
  //月だけ+1すること
  const monthStr = baseDate.getMonth() + 1;
  const dayStr = baseDate.getDate();
  let formatStr = 'YYYY-MM-DD';
  formatStr = formatStr.replace(/YYYY/g, yearStr.toString());
  formatStr = formatStr.replace(/MM/g, monthStr.toString());
  formatStr = formatStr.replace(/DD/g, dayStr.toString());
  return formatStr;
};
const styles = {
  formInput: {
    width: '47%',
  },
  deliveryArea: {
    paddingTop: '20px',
    width: '60%',
    margin: 'auto',
  },
  amountLabel: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  datePickerLabel: {
    fontSize: '24px',
    fontWeight: 'bold',
    width: '57%',
  },
  labelSquareStyle: {
    width: '21px',
  },
  selectField: {
    marginLeft: '10px',
  },
  rateInput: {
    overflow: 'hidden',
    border: 'solid #94a3b8',
    borderWidth: '2px',
    paddingRight: '0.25rem',
    paddingLeft: '0.25rem',
  },
};

/**
 * 内示計算用の割合を変更する
 * @param value - 内示計算用の割合
 */
const rateChange = (value) => {
  state.rate = value;
};

/**
 * 内示計算用の割合をリセットする
 */
const resetForecastRate = () => {
  // 内示計算用の割合を等倍に戻す（連打による連続回計算処理の防止策）
  state.rate = EQUAL_RATE;
};

/**
 * 関連取引モーダルを開く
 */
const openRelatedTransactionsModal = async () => {
  await recommendOrderStore.openRelatedTransactionsModal(props.item.businessId);
};

/**
 * リードタイムピッカーを開く
 * @param event - ボタンのクリックイベント
 */
const openLeadTimePicker = (event: MouseEvent) => {
  state.leadTimePickerState.originCoordinate.x = event.clientX;
  state.leadTimePickerState.originCoordinate.y = event.clientY;
  state.leadTimePickerState.shouldShow = true;
};
/**
 * リードタイムピッカーを閉じる
 */
const closeLeadTimePicker = () => {
  state.leadTimePickerState.shouldShow = false;
};
/**
 * リードタイムピッカーで選択した値を反映させる
 * @param value - リードタイムピッカーで選択した値
 */
const onConfirmLeadTimePicker = (value: ISelectFormDataSet) => {
  leadTimeChange(value);
  closeLeadTimePicker();
};

/**
 * 標準在庫指数ピッカーを開く
 * @param event - ボタンのクリックイベント
 */
const openStdInventoryPicker = (event: MouseEvent) => {
  state.stdInventoryPickerState.originCoordinate.x = event.clientX;
  state.stdInventoryPickerState.originCoordinate.y = event.clientY;
  state.stdInventoryPickerState.shouldShow = true;
};
/**
 * 標準在庫指数ピッカーを閉じる
 */
const closeStdInventoryPicker = () => {
  state.stdInventoryPickerState.shouldShow = false;
};
/**
 * 標準在庫指数ピッカーで選択した値を反映させる
 * @param value - 標準在庫指数ピッカーで選択した値
 */
const onStdInventoryPicker = (value: StdIndexInfo) => {
  stdIndexChange(value);
  closeStdInventoryPicker();
};

//computed
const orderChartStyles = computed(() => {
  return {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
  };
});

/**
 * csv出力関数に渡すためにグラフ出力情報を整理する
 * string型の2次元配列の作成を行なう
 * @param formSet - シミュレーションの結果
 * @param chartData - グラフの出力情報
 * @param extraSimulateInfos - シミュレーションの結果(リードタイムと標準在庫指数を取るために必要)
 */
const createChartDataForCsv = (formSet: IBusiness, chartData: IChartdata, extraSimulateInfos?: IExtraSimulate): CreateCsvInfo => {
  // 出力用の二次元配列
  const outputArray: string[][] = [];

  // 取引概要の情報を配列に入れる
  const businessInfoArray: string[] = [formSet.warehouse, formSet.supplierName, formSet.businessName ?? '', formSet.package];
  outputArray.push(businessInfoArray, ['']); // 取引概要と空行を追加する

  // リードタイムと標準在庫指数の追加を行う
  // TODO: formSetだと、画面で値を変えた後の情報を取得できない
  const leadTimeAndStdIndex = [
    vm.displayTableContent(nullOrUndefinedToMinusOne(extraSimulateInfos?.extraLeadTime ?? 0)),
    vm.getDisplayStdInventory(formSet, extraSimulateInfos?.extraStdInventory),
  ];
  // 出力用配列に、タイトル、それぞれの情報、空行を追加する
  outputArray.push(['リードタイム', '標準在庫指数'], leadTimeAndStdIndex, ['']);

  // 客先内示の追加を行う
  outputArray.push(['客先内示']); // タイトル行

  // 客先内示情報の取得
  if (extraSimulateInfos?.extraAnnounce) {
    const customerAnnounceInfo: IAnnounce[] = [];

    // 年月が条件に一致する客先内示情報のみに絞る
    for (let i = 0; i < 4; i++) {
      const targetYearMonth: IYearMonth = DateService.getShiftedIYearMonthFromNowDateByMonths(i);
      extraSimulateInfos?.extraAnnounce.forEach((ele) => {
        if (DateService.equalYearMonthInfo({ year: ele.year, month: ele.month }, targetYearMonth)) {
          customerAnnounceInfo.push(ele);
        }
      });
    }
    outputArray.push(
      ['年月'].concat(
        customerAnnounceInfo.map((info) => DateService.convertIYearMonthToYYYYMMDivideSlash({ year: info.year, month: info.month }))
      )
    );
    outputArray.push(['内示数量'].concat(customerAnnounceInfo.map((info) => String(info.amount))));
  }

  // 空行を追加する
  outputArray.push([''], ['グラフデータ']);

  // グラフ構成情報
  // ラベル(年月情報)を配列に追加していく、一番左の列は、行タイトル分開ける
  const labelArray: string[] = ['年月日'].concat(chartData.labels.map(String)); // 行タイトル分1列空列を入れる
  // 出力用の配列に追加する
  outputArray.push(labelArray);

  // グラフを構成するデータセットの追加
  chartData.datasets.forEach((dataset) => {
    // 先に行タイトルおよびグラフを構成するデータを配列に追加する
    const datasetArray = [dataset.label ?? ''].concat(dataset.data.map((data) => String(Math.floor(data ?? 0))));
    outputArray.push(datasetArray);
  });

  // csv作成用のオブジェクトに情報を追加
  const title = businessInfoArray.join(' ');
  return { data: outputArray, title: `グラフデータ_${title}` };
};

/**
 * string型の2次元配列を受けとってcsvファイル作成関数に投げる
 * TODO: exportFileManagerに移動させる
 */
const exportChartDataCsv = async () => {
  const input: CreateCsvInfo = createChartDataForCsv(state.formSet, state.chartData as IChartdata, props.extraSimulateInfos);
  const res = await createChartDataForCsvUseCase.Execute(input);
  switch (res.status.type) {
    case 'success':
      break;
    case 'error':
      await openFailToSavedModal();
      break;
  }
};

/**
 * 過去実績の月を変更する
 * @param value - 変更後の値
 */
const historyMonthOffsetUpdate = (value: string) => {
  const newOffset = Number(value.charAt(0));
  state.historyMonthOffset = newOffset;
  setHistoryValue();
  state.futureForecasts = calculateFutureForecasts(state.formSetCustomerForecastHistory);
  const currentMonthSalesResult = calculateCurrentMonthSalesResult(state.formSet?.salesResults || []);
  state.currentMonthData = currentMonthSalesResult
    ? {
        salesResult: currentMonthSalesResult,
        quantityRate: getQuantityRate(
          state.futureForecasts.find((v) => v.year == currentMonthSalesResult.year && v.month == currentMonthSalesResult.month)?.amount ??
            0,
          currentMonthSalesResult.amount
        ),
      }
    : undefined;
  state.quantityRate = [];
  state.turnOverHistory = [];
  initQuantityRate();
  initTurnOver();
};

/**
 * MOQを指定するポップアップを開く
 * @param event - マウスイベント
 */
const openMOQInput = (event: MouseEvent) => {
  const moqContent = document.getElementsByClassName(
    'order-form-simulation-graph-button-container__moq-info__text-button'
  )[0] as HTMLElement;
  state.moqInputPopUpState.originCoordinate.x = moqContent.offsetLeft;
  state.moqInputPopUpState.originCoordinate.y = moqContent.offsetTop + moqContent.offsetHeight;
  state.moqInputPopUpState.shouldShow = true;
};

/**
 * 発注単位を指定するポップアップを開く
 * @param event - マウスイベント
 */
const openOrderPackageInput = (event: MouseEvent) => {
  const orderPackageContent = document.getElementsByClassName(
    'order-form-simulation-graph-button-container__order-package-info__text-button'
  )[0] as HTMLElement;
  state.orderPackageInputPopUpState.originCoordinate.x = orderPackageContent.offsetLeft;
  state.orderPackageInputPopUpState.originCoordinate.y = orderPackageContent.offsetTop + orderPackageContent.offsetHeight;
  state.orderPackageInputPopUpState.shouldShow = true;
};

/**
 * MOQを指定するポップアップを閉じる
 */
const closeMOQInput = () => {
  state.moqModelValue = props.item?.MOQ ?? 0;
  state.moqInputPopUpState.shouldShow = false;
};

/**
 * 発注単位を指定するポップアップを閉じる
 */
const closeOrderPackageInput = () => {
  state.orderPackageModelValue = props.item?.orderPackage ?? 0;
  state.orderPackageInputPopUpState.shouldShow = false;
};

/**
 * MOQを更新する
 */
const updateMOQ = async () => {
  const result = await recommendOrderStore.onUpdateMoq(state.moqModelValue);
  if (result) state.moqInputPopUpState.shouldShow = false;
};

/**
 * 発注単位を更新する
 */
const updateOrderPackage = async () => {
  const result = await recommendOrderStore.onUpdateOrderPackage(state.orderPackageModelValue);
  if (result) state.orderPackageInputPopUpState.shouldShow = false;
};

/**
 * メモを更新する
 * @param value - メモのテキスト
 */
const updateMemo = async (value: string) => {
  await recommendOrderStore.updateMemo(value);
};

/**
 * メモを削除する
 */
const deleteMemo = async () => {
  await recommendOrderStore.deleteMemo();
};

/**
 * ページングボタンの活性/非活性を制御する
 * @param type - ページングの向き
 */
const pagingButtonDisabledControl = (type: 'previous' | 'next') => {
  const aggregateBusinessIdsHasRecommendOrderIndex = useSelectedBusinessState.aggregateBusinessIdsHasRecommendOrder.indexOf(
    state.formSet.businessId
  );
  if (type === 'previous') {
    return aggregateBusinessIdsHasRecommendOrderIndex === 0;
  } else {
    return aggregateBusinessIdsHasRecommendOrderIndex === useSelectedBusinessState.aggregateBusinessIdsHasRecommendOrder.length - 1;
  }
};

/**
 * ページングを更新する
 * @param type - ページングの向き
 */
const pagingUpdate = (type: 'previous' | 'next') => {
  const pageIndex = useSelectedBusinessState.recommendOrderPagingOption.pageIndex;
  if (type === 'previous') {
    const changePageIndex = pageIndex - 1 < 0 ? 0 : pageIndex - 1;
    useSelectedBusinessState.recommendOrderPagingOption.pageIndex = changePageIndex;
    emits('pagingUpdate', useSelectedBusinessState.aggregateBusinessIdsHasRecommendOrder[changePageIndex]);
  } else {
    const changePageIndex =
      pageIndex + 1 >= useSelectedBusinessState.aggregateBusinessIdsHasRecommendOrder.length
        ? useSelectedBusinessState.aggregateBusinessIdsHasRecommendOrder.length - 1
        : pageIndex + 1;
    useSelectedBusinessState.recommendOrderPagingOption.pageIndex = changePageIndex;
    emits('pagingUpdate', useSelectedBusinessState.aggregateBusinessIdsHasRecommendOrder[changePageIndex]);
  }
};

/**
 * 任意項目の値を表示する
 * 対象の値: MOQ、発注単位
 * @param value - 任意項目の値
 * @returns - 任意項目の値を表示する文字列
 */
const displayOptionalItemValue = (value: number | undefined): string => {
  return value ? value.addComma() : '-';
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(WorkDaysCalendarNotYetEnteredAlertModal, {
      "is-open-modal": state.workDaysCalendarNotYetEnteredAlertModalStatus,
      onOutsideClick: _cache[0] || (_cache[0] = ($event: any) => (closeWorkDaysCalendarNotYetEnteredAlertModal()))
    }, null, 8, ["is-open-modal"]),
    _createElementVNode("div", {
      class: "order-form",
      onClick: orderFormEl
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('取引概要(詳細ページ)')), 1),
        (_unref(useSelectedBusinessState).aggregateBusinessIdsHasRecommendOrder.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "page-top__page-nation--arrow",
                disabled: pagingButtonDisabledControl('previous'),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (pagingUpdate('previous')))
              }, [
                _createVNode(SvgLoader, {
                  name: "arrowLeft",
                  class: "page-move__left"
                }),
                _createElementVNode("span", _hoisted_5, _toDisplayString(_unref(t)('前へ')), 1)
              ], 8, _hoisted_4),
              _createElementVNode("button", {
                class: "page-top__page-nation--arrow",
                disabled: pagingButtonDisabledControl('next'),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (pagingUpdate('next')))
              }, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('次へ')), 1),
                _createVNode(SvgLoader, {
                  name: "arrowRight",
                  class: "page-move__right"
                })
              ], 8, _hoisted_6),
              _createElementVNode("span", _hoisted_8, _toDisplayString(`${_unref(useSelectedBusinessState).aggregateBusinessIdsHasRecommendOrder.indexOf(state.formSet.businessId) + 1}/${
              _unref(useSelectedBusinessState).aggregateBusinessIdsHasRecommendOrder.length
            }`), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(SelectableSimpleTableContent, {
            "table-type": 'simpleBusinessSummary',
            business: state.formSet,
            "editable-lead-time": true,
            "editable-std-inventory": true,
            "table-body-font-size": 'fontSizeS',
            onOnClickLeadTimeButton: openLeadTimePicker,
            onOnClickStdInventoryButton: openStdInventoryPicker
          }, null, 8, ["business"])
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('製造社') + ` : ${props.item.manufacturer ? props.item.manufacturer : '--'}`), 1)
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", null, _toDisplayString(_unref(t)('最新在庫数(詳細ページ)') + ` : ${props.item.inventory?.addComma()}`), 1)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                class: "order-form-simulation-graph-button-container__moq-info__text-button",
                onClick: openMOQInput
              }, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)('MOQ(詳細ページ)') + ` : ${displayOptionalItemValue(props.item.MOQ)}`), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", {
                class: "order-form-simulation-graph-button-container__order-package-info__text-button",
                onClick: openOrderPackageInput
              }, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)('発注単位(詳細ページ)') + ` : ${displayOptionalItemValue(props.item.orderPackage)}`), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(TableMemoButton, {
                memo: props.item.note,
                "need-confirm-deletion": false,
                "need-label-text": true,
                onSave: updateMemo,
                onDelete: deleteMemo
              }, null, 8, ["memo"])
            ]),
            _createElementVNode("button", {
              class: "accordion-toggle-button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (isExpanded.value = !isExpanded.value))
            }, [
              _createVNode(Mdi, {
                icon: "expand_more",
                class: _normalizeClass(["accordion-toggle-icon", { 'is-expanded': isExpanded.value }])
              }, null, 8, ["class"])
            ])
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(OptimizedTooltipText, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('仕入担当者') + ' : ') + " ", 1),
                  (props.item.aggregateBusinessResponsibleUsers && props.item.aggregateBusinessResponsibleUsers.length > 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.item.aggregateBusinessResponsibleUsers, (user, index) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: user.email
                          }, _toDisplayString(user.name) + _toDisplayString(index < props.item.aggregateBusinessResponsibleUsers.length - 1 ? ', ' : ''), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_22, " -- "))
                ], undefined, true),
                _: 1
              })
            ])
          ], 512), [
            [_vShow, isExpanded.value]
          ])
        ]),
        _createVNode(MoqInputPopUp, {
          class: "moq-input-popup",
          "model-value": state.moqModelValue,
          "pop-up-state": state.moqInputPopUpState.shouldShow,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = (value) => (state.moqModelValue = value)),
          onClose: closeMOQInput,
          onConfirm: updateMOQ
        }, null, 8, ["model-value", "pop-up-state"]),
        _createVNode(OrderPackageInputPopUp, {
          class: "order-package-input-popup",
          "model-value": state.orderPackageModelValue,
          "pop-up-state": state.orderPackageInputPopUpState.shouldShow,
          "onUpdate:modelValue": _cache[5] || (_cache[5] = (value) => (state.orderPackageModelValue = value)),
          onClose: closeOrderPackageInput,
          onConfirm: updateOrderPackage
        }, null, 8, ["model-value", "pop-up-state"]),
        _createVNode(TextButton, {
          class: "order-form-simulation-graph-button-container__update-button",
          color: "primary",
          size: 'btn-md',
          disabled: disableUpdateBusinessBtn.value,
          onClick: _cache[6] || (_cache[6] = ($event: any) => (emits('updateBusinessId')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('表示情報を更新(詳細ページ)')) + " ", 1),
            _createVNode(SvgLoader, {
              class: "order-form-simulation-graph-button-container__update-button--loop-icon",
              name: 'loopIcon',
              "data-testid": "loop_icon"
            })
          ], undefined, true),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(t)('過去実績一覧(詳細ページ)')), 1),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, [
            _createVNode(SimpleSelectInput, {
              class: "forecast-history__label-change-month-input",
              index: 1,
              "select-box-name": "SELECT_PAST_FORCAST_FOR_RECEIPT_MONTH",
              "model-value": state.historyMonthOffset + 'ヶ月前内示',
              "prop-options": ['1ヶ月前内示', '2ヶ月前内示', '3ヶ月前内示'],
              "display-allow": "",
              "onUpdate:modelValue": historyMonthOffsetUpdate
            }, null, 8, ["model-value"])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", _hoisted_28, _toDisplayString(_unref(t)('平均正答率(詳細ページ)') + ` : `), 1),
            _createElementVNode("p", _hoisted_29, _toDisplayString(_unref(vm).displayFromNumberToString(calcAverageQuantityRate())), 1),
            _cache[12] || (_cache[12] = _createElementVNode("p", { class: "forecast-history__label-percentage--mark" }, "%", -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("table", _hoisted_32, [
            _createElementVNode("thead", _hoisted_33, [
              _createElementVNode("tr", null, [
                _createVNode(TableHead, {
                  "font-size": 'fontSizeS',
                  "background-color": 'bg-default',
                  class: "forecast-history__table--side-header-empty px-2 font-semibold sticky"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('')), 1)
                  ], undefined, true),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showAnnounceHistory.value, (property, index) => {
                  return (_openBlock(), _createBlock(TableHead, {
                    key: `first-${index}`,
                    "text-align": 'left',
                    "font-size": 'fontSizeS',
                    "background-color": 'bg-default'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('displayShortDate', { year: property.year, month: _unref(DateService).convertMonthWithZero(property.month) })), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.futureForecasts, (property, index) => {
                  return (_openBlock(), _createBlock(TableHead, {
                    key: `future-header-${index}`,
                    "text-align": 'left',
                    "font-size": 'fontSizeS',
                    "background-color": 'bg-default'
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('displayShortDate', { year: property.year, month: _unref(DateService).convertMonthWithZero(property.month) })), 1)
                    ], undefined, true),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _createVNode(TableHead, {
                  "font-size": 'fontSizeS',
                  "background-color": 'bg-default',
                  class: "forecast-history__table--side-header px-2 py-1 sticky"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('正答率(詳細ページ)')), 1)
                  ], undefined, true),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showQuantityRate.value, (property, index) => {
                  return (_openBlock(), _createBlock(TableCell, {
                    key: `first-${index}`,
                    "tool-tip-value": _unref(vm).displayFromNumberToString(property) + '%',
                    "font-size": 'fontSizeS',
                    "is-border": false,
                    class: "forecast-history__table--cell-value"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(vm).displayFromNumberToString(property) + '%'), 1)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["tool-tip-value"]))
                }), 128)),
                _createVNode(TableCell, {
                  "tool-tip-value": _unref(vm).displayFromNumberToString(state.currentMonthData?.quantityRate) + '%',
                  "font-size": 'fontSizeS',
                  "is-border": false,
                  class: "forecast-history__table--cell-value"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(vm).displayFromNumberToString(state.currentMonthData?.quantityRate) + '%'), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["tool-tip-value"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.futureForecasts.slice(0, -1), (property, index) => {
                  return (_openBlock(), _createBlock(TableCell, {
                    key: `future-accuracy-${index}`,
                    "tool-tip-value": '-',
                    "font-size": 'fontSizeS',
                    "is-border": false,
                    class: "forecast-history__table--cell-value"
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode(" - ")
                    ]), undefined, true),
                    _: 1,
                    __: [13]
                  }))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _createVNode(TableHead, {
                  "font-size": 'fontSizeS',
                  "background-color": 'bg-default',
                  class: "forecast-history__table--side-header sticky"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('在庫回転率(詳細ページ)')), 1)
                  ], undefined, true),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showTurnOverHistory.value, (property, index) => {
                  return (_openBlock(), _createBlock(TableCell, {
                    key: `first-${index}`,
                    "tool-tip-value": property.turnOver.addComma(),
                    "font-size": 'fontSizeS',
                    "is-border": false,
                    class: "forecast-history__table--cell-value"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(property.turnOver.addComma()), 1)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["tool-tip-value"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.futureForecasts, (property, index) => {
                  return (_openBlock(), _createBlock(TableCell, {
                    key: `future-turnover-${index}`,
                    "tool-tip-value": property.inventoryTurnoverRate.addComma(),
                    "font-size": 'fontSizeS',
                    "is-border": false,
                    class: "forecast-history__table--cell-value"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(property.inventoryTurnoverRate.addComma()), 1)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["tool-tip-value"]))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _createVNode(TableHead, {
                  "font-size": 'fontSizeS',
                  "background-color": 'bg-default',
                  class: "forecast-history__table--side-header sticky"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "forecast-history__table--cell-link",
                      onClick: _cache[7] || (_cache[7] = ($event: any) => (openRelatedTransactionsModal()))
                    }, _toDisplayString(_unref(t)('販売実績(詳細ページ)')), 1)
                  ], undefined, true),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showSalesResultHistory.value, (property, index) => {
                  return (_openBlock(), _createBlock(TableCell, {
                    key: `first-${index}`,
                    "tool-tip-value": property.amount.addComma(),
                    "font-size": 'fontSizeS',
                    "is-border": false,
                    class: "forecast-history__table--cell-value"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(property.amount.addComma()), 1)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["tool-tip-value"]))
                }), 128)),
                _createVNode(TableCell, {
                  "tool-tip-value": state.currentMonthData?.salesResult.amount.addComma() ?? '-',
                  "font-size": 'fontSizeS',
                  "is-border": false,
                  class: "forecast-history__table--cell-value"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(state.currentMonthData?.salesResult.amount.addComma() ?? '-'), 1)
                  ], undefined, true),
                  _: 1
                }, 8, ["tool-tip-value"]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.futureForecasts.slice(0, -1), (property, index) => {
                  return (_openBlock(), _createBlock(TableCell, {
                    key: `future-sales-${index}`,
                    "tool-tip-value": '-',
                    "font-size": 'fontSizeS',
                    "is-border": false,
                    class: "forecast-history__table--cell-value"
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode(" - ")
                    ]), undefined, true),
                    _: 1,
                    __: [14]
                  }))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _createVNode(TableHead, {
                  "font-size": 'fontSizeS',
                  "background-color": 'bg-default',
                  class: "forecast-history__table--side-header px-2 py-1 sticky"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: "forecast-history__table--cell-link",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (openRelatedTransactionsModal()))
                    }, _toDisplayString(_unref(t)('内示(詳細ページ)')), 1)
                  ], undefined, true),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showAnnounceHistory.value, (property, index) => {
                  return (_openBlock(), _createBlock(TableCell, {
                    key: `first-${index}`,
                    "tool-tip-value": property.amount.addComma(),
                    "font-size": 'fontSizeS',
                    "is-border": false,
                    class: "forecast-history__table--cell-value"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(property.amount.addComma()), 1)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["tool-tip-value"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.futureForecasts, (property, index) => {
                  return (_openBlock(), _createBlock(TableCell, {
                    key: `future-forecast-${index}`,
                    "tool-tip-value": (property.amount ?? 0).addComma(),
                    "font-size": 'fontSizeS',
                    "is-border": false,
                    class: "forecast-history__table--cell-value"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString((property.amount ?? 0).addComma()), 1)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["tool-tip-value"]))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                _createVNode(TableHead, {
                  "font-size": 'fontSizeS',
                  "background-color": 'bg-default',
                  class: "forecast-history__table--side-header sticky"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('月末在庫(詳細ページ)')), 1)
                  ], undefined, true),
                  _: 1
                }),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showInventoryHistory.value, (property, index) => {
                  return (_openBlock(), _createBlock(TableCell, {
                    key: `first-${index}`,
                    "tool-tip-value": property.amount.addComma(),
                    "font-size": 'fontSizeS',
                    "is-border": false,
                    class: "forecast-history__table--cell-value"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(property.amount.addComma()), 1)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["tool-tip-value"]))
                }), 128)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.futureForecasts, (property, index) => {
                  return (_openBlock(), _createBlock(TableCell, {
                    key: `future-inventory-${index}`,
                    "tool-tip-value": property.endOfMonthInventory.addComma(),
                    "font-size": 'fontSizeS',
                    "is-border": false,
                    class: "forecast-history__table--cell-value"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(property.endOfMonthInventory.addComma()), 1)
                    ], undefined, true),
                    _: 2
                  }, 1032, ["tool-tip-value"]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)('在庫推移予測(詳細ページ)')), 1),
        _createElementVNode("div", _hoisted_36, [
          (state.isAppearenceUnpaidOrderedOrder)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "order-form__unpaid-ordered-order-notify",
                onClick: _cache[9] || (_cache[9] = () => _unref(recommendOrderStore).openUnpaidOrderedOrderInfoModal())
              }, _toDisplayString(_unref(t)('発注済みで未納になっている発注があります')), 1))
            : _createCommentVNode("", true),
          _createVNode(TextButton, {
            class: _normalizeClass(["order-form-simulation-graph-button-container__output-button", _unref(recommendOrderStore)?.state.errorType ? 'order-form-simulation-graph-button-container__output-button--inactive' : '']),
            "button-style": 'btn-cancel',
            size: 'btn-md',
            "tool-tip-value": '',
            onClick: _cache[10] || (_cache[10] = ($event: any) => (exportChartDataCsv()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('グラフデータ出力(詳細ページ)')) + " ", 1),
              _createVNode(SvgLoader, {
                class: "order-form-simulation-graph-button-container__output-button--arrow-icon",
                name: 'fatArrowDown',
                "data-testid": "fat_arrow_down_icon"
              })
            ], undefined, true),
            _: 1
          }, 8, ["class"])
        ])
      ]),
      _createElementVNode("div", _hoisted_37, [
        _createVNode(Chart, {
          "date-unit": state.selectedDateUnit,
          width: 900,
          height: 400,
          styles: orderChartStyles.value,
          "chart-data": state.chartData
        }, null, 8, ["date-unit", "styles", "chart-data"]),
        _withDirectives(_createElementVNode("div", _hoisted_38, [
          _withDirectives(_createElementVNode("input", {
            id: "range-1",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((state.inputGraphRange[1]) = $event)),
            class: "thumb-1",
            type: "range",
            name: "range-1",
            max: "180",
            step: "1",
            min: "0"
          }, null, 512), [
            [_vModelText, state.inputGraphRange[1]]
          ]),
          _createElementVNode("span", _hoisted_39, _toDisplayString(showGraphRange('left')), 1),
          _createElementVNode("span", _hoisted_40, _toDisplayString(showGraphRange('right')), 1)
        ], 512), [
          [_vShow, !(state.selectedDateUnit === 'month')]
        ]),
        (_unref(recommendOrderStore)?.state.errorType)
          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createVNode(InvalidOrderAlert, {
                class: "simulate-graph__alert-content",
                "error-type": _unref(recommendOrderStore).state.errorType
              }, null, 8, ["error-type"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(LeadTimePicker, {
        class: "lead-time-picker",
        "popup-state": state.leadTimePickerState.shouldShow,
        "lead-time-set": state.leadTimeSet,
        onOnClose: closeLeadTimePicker,
        onOnConfirm: onConfirmLeadTimePicker
      }, null, 8, ["popup-state", "lead-time-set"]),
      _createVNode(StdInventoryPicker, {
        class: "std-inventory-picker",
        "popup-state": state.stdInventoryPickerState.shouldShow,
        "std-inventory-info": state.displayStdIndexInfo,
        onOnClose: closeStdInventoryPicker,
        onOnConfirm: onStdInventoryPicker
      }, null, 8, ["popup-state", "std-inventory-info"]),
      _createVNode(RelatedTransactionsModal, {
        "business-id": props.item.businessId
      }, null, 8, ["business-id"])
    ])
  ], 64))
}
}

})